var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteTimer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10727_47904)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99935 13.9987C5.05383 13.9987 2.66602 11.6109 2.66602 8.66536C2.66602 5.71985 5.05383 3.33203 7.99935 3.33203C10.9449 3.33203 13.3327 5.71985 13.3327 8.66536C13.3327 11.6109 10.9449 13.9987 7.99935 13.9987Z",
    fill: "#506EFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66667 3.37329C8.44827 3.34606 8.22577 3.33203 8 3.33203C7.77423 3.33203 7.55173 3.34606 7.33333 3.37329V2.66536H6.66667C6.29848 2.66536 6 2.36689 6 1.9987C6 1.63051 6.29848 1.33203 6.66667 1.33203H9.33333C9.70152 1.33203 10 1.63051 10 1.9987C10 2.36689 9.70152 2.66536 9.33333 2.66536H8.66667V3.37329Z",
    fill: "#506EFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1406 4.35407L11.691 3.80366C11.9514 3.54331 12.3735 3.54331 12.6338 3.80366C12.8942 4.06401 12.8942 4.48612 12.6338 4.74647L12.1121 5.26821C11.8279 4.92462 11.5014 4.61726 11.1406 4.35407Z",
    fill: "#506EFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.97476 5H8.02407C8.19825 5 8.34306 5.1341 8.35642 5.30777L8.63847 8.97443C8.65259 9.15799 8.51524 9.31823 8.33169 9.33235C8.32318 9.33301 8.31465 9.33333 8.30612 9.33333H7.69271C7.50861 9.33333 7.35938 9.18409 7.35938 9C7.35938 8.99147 7.3597 8.98294 7.36036 8.97443L7.64241 5.30777C7.65577 5.1341 7.80058 5 7.97476 5Z",
    fill: "#506EFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10727_47904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteTimer);
export default __webpack_public_path__ + "static/media/deleteTimer.66e5c552c9a065d9a339ad01f1e3fee2.svg";
export { ForwardRef as ReactComponent };